export default __webpack_public_path__ + "static/media/footer_logo_ikara.797a2026.svg";